import angular from "angular";

angular
    .module('stationsControl.station', [])
    .service('Station', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/stations';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.sync = function (id) {
            return $http.post(uri(null, 'sync'), {stationSyncId: id});
        };

        this.update = function (id, params) {
            return $http.post(uri(id, 'update'), params);
        };

    }]);

export default 'stationsControl.station';



// WEBPACK FOOTER //
// ./resources/assets/modules/stations-control/station.js